// Silo Cube — shared face/tab definitions.
// Mirrors the in-place swipe map in components/SiloCubeCard.jsx:
//   left  = AI Assistant
//   right = tab chain (Staging → … → Settings)
//   up    = Public Q&A → Account & Billing → Admin (founder only)
//   down  = Fan Portal → Silo Wars
export const SILO_TAB_FACES = [
  { id: "staging", label: "Staging" },
  { id: "workbench", label: "Workbench" },
  { id: "file-refinery", label: "Refinery" },
  { id: "conversations", label: "Chats" },
  { id: "ytre", label: "YTRE" },
  { id: "users", label: "Users" },
  { id: "operations", label: "Ops" },
  { id: "probe", label: "Probe" },
  { id: "tone", label: "Tone" },
  { id: "settings", label: "Settings" },
];

// Studio face map, grouped to match the swipe layout. Rendered as:
//   up group (above home) · middle row (home + assistant + tabs) · down group.
export const STUDIO_LAYOUT = {
  up: [
    { id: "public-qa", label: "Public Q&A" },
    { id: "account", label: "Account & Billing" },
    { id: "admin", label: "Admin", founderOnly: true },
  ],
  mid: [
    { id: "assistant", label: "AI Assistant" },
    { id: "center", label: "Home (main)" },
    ...SILO_TAB_FACES,
  ],
  down: [
    { id: "fan-portal", label: "Fan Portal" },
    { id: "wars", label: "Silo Wars" },
  ],
};

// Flat list of every assignable face (used by apply/undo + label lookups).
export const STUDIO_FACES = [
  ...STUDIO_LAYOUT.up,
  ...STUDIO_LAYOUT.mid,
  ...STUDIO_LAYOUT.down,
];

// Adjacency graph for in-place face navigation. center is home.
export const FACES = {
  center: { left: "assistant", right: "staging", up: "public-qa", down: "fan-portal" },
  assistant: { right: "center" },
  "public-qa": { down: "center", up: "account" },
  account: { down: "public-qa", up: "admin" },
  admin: { down: "account" },
  "fan-portal": { up: "center", down: "wars" },
  wars: { up: "fan-portal" },
  staging: { left: "center", right: "workbench" },
  workbench: { left: "staging", right: "file-refinery" },
  "file-refinery": { left: "workbench", right: "conversations" },
  conversations: { left: "file-refinery", right: "ytre" },
  ytre: { left: "conversations", right: "users" },
  users: { left: "ytre", right: "operations" },
  operations: { left: "users", right: "probe" },
  probe: { left: "operations", right: "tone" },
  tone: { left: "probe", right: "settings" },
  settings: { left: "tone", right: "center" },
};

export const LABELS = {
  center: "Home",
  assistant: "AI Assistant",
  "public-qa": "Public Q&A",
  wars: "Silo Wars",
  "fan-portal": "Fan Portal",
  account: "Account & Billing",
  admin: "Admin",
  staging: "Staging",
  workbench: "Workbench",
  "file-refinery": "Refinery",
  conversations: "Chats",
  ytre: "YTRE",
  users: "Users",
  operations: "Ops",
  probe: "Probe",
  tone: "Tone",
  settings: "Settings",
};


// Inline CSS for a saved face framing (zoom + pan). Returns undefined for the
// default (centered, no zoom) so we don't emit a pointless transform.
export const cropStyle = (crop) =>
  crop && (Number(crop.scale) > 1 || crop.px !== 50 || crop.py !== 50)
    ? {
        objectPosition: `${crop.px}% ${crop.py}%`,
        transform: `scale(${crop.scale})`,
        transformOrigin: `${crop.px}% ${crop.py}%`,
      }
    : undefined;
